import { FC } from 'react'

import { Button as MerinioButton } from 'ui'

import styles from './styles.module.scss'

type Props = {
  isOpen: boolean
  fullScreenContentClassName?: string
  onClose: () => void
  children: React.ReactNode
}

const FullScreen: FC<Props> = ({ children, onClose, isOpen, fullScreenContentClassName }) => {
  if (!isOpen) return null

  return (
    <div className={styles.fullScreen}>
      <MerinioButton className="p-0 pr-2" onClick={onClose}>
        <i className={`fa fa-angle-left ${styles.close}`} />
      </MerinioButton>
      <div className={`mt-2 ${fullScreenContentClassName} p-2`}>{children}</div>
    </div>
  )
}

export { FullScreen }
